import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import Header from "./Components/Header/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Nav from "./Components/Section/Nav";
import Footer from "./Components/Footer/Footer";
import BlogComponent from "./Components/BlogComponent/BlogComponent";
import AboutusBanner from "./Components/Aboutsection/AboutusBanner";
import Oneonone from "./Components/Aboutsection/Oneonone";
import InfrastructureFacilities from "./Components/Aboutsection/InfraAndFacilities";
import MissionVision from "./Components/Aboutsection/MissionVision";
import CoreCompetencies from "./Components/Aboutsection/CoreCompetency";
import GetInTouch from "./Components/Aboutsection/GetInTouch";
import Home from "./Components/Home/Home";
import { FriendlyUrlComponent } from "./Components/FriendlyUrlComponent/FriendlyUrlComponent";
import Contact from "./Components/Contact/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/about"
            element={
              <>
                <AboutusBanner />
                <Oneonone />
                <InfrastructureFacilities />
                <MissionVision />
                <CoreCompetencies />
                <GetInTouch />
              </>
            }
          />
          <Route path="/contact" element={<Contact />} />
          <>
            <Route path="/blog" element={<BlogComponent />} />
            <Route path="/:seo_url" element={<FriendlyUrlComponent />} />
            <Route
              path=" /:seo_url/"
              element={<FriendlyUrlComponent />}
            />
          </>
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
